import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useGetModelsService } from "@hooks";

export interface SelectedCountry {
  name: string;
  acronym: string;
  totalModels: number;
  soon: boolean;
  cities: { name?: string | null; totalModels?: number | null }[];
}

const ACCENT = "#d4163c";

export const CityBar: React.FC<{ country: SelectedCountry | null }> = ({
  country,
}) => {
  const { handleGetModelsByCity } = useGetModelsService();
  const location = useLocation();
  const [active, setActive] = useState<string>("");

  useEffect(() => {
    setActive("");
  }, [country]);

  if (!country || location.pathname !== "/") return null;

  const boxSx = {
    backgroundColor: "#141414",
    borderBottom: "2px solid " + ACCENT,
    borderRadius: "8px",
    padding: "12px 16px",
    marginBottom: "18px",
  };

  if (country.soon) {
    return (
      <Box sx={{ ...boxSx, textAlign: "center", color: "#ddd", fontSize: 15 }}>
        We are adding models in {country.name}. Come back soon!
      </Box>
    );
  }

  const cities = country.cities
    .filter((c) => !!c.name && (c.totalModels ?? 0) > 0)
    .sort((a, b) => String(a.name).localeCompare(String(b.name)));

  const itemSx = (on: boolean) => ({
    fontSize: 14,
    padding: "5px 10px",
    borderRadius: "6px",
    cursor: "pointer",
    color: "#fff",
    backgroundColor: on ? ACCENT : "transparent",
    "&:hover": { backgroundColor: on ? ACCENT : "rgba(255,255,255,.08)" },
    "& span": { color: on ? "#ffd6de" : "#888", marginLeft: "3px" },
  });

  const pick = (key: string, name: string) => {
    setActive(key);
    handleGetModelsByCity(name);
  };

  return (
    <Box
      sx={{
        ...boxSx,
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
        gap: "6px 10px",
      }}
    >
      <Box sx={itemSx(active === "")} onClick={() => pick("", country.name)}>
        All<span>({country.totalModels})</span>
      </Box>
      {cities.map((c) => (
        <Box
          key={String(c.name)}
          sx={itemSx(active === c.name)}
          onClick={() => pick(String(c.name), String(c.name))}
        >
          {c.name}
          <span>({c.totalModels ?? 0})</span>
        </Box>
      ))}
    </Box>
  );
};

export default CityBar;
